import { useEffect } from "react";
import "./LandingPage.css";
import deviceImage from "../../assets/images/Deviceimage.jpg";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Footer from '../../Layout/Footer';


const LandingPage = () => {
  useEffect(() => {
    //  createIcons();

    // Generate satellite grid
    const satelliteGrid = document.querySelector(".satellite-grid");
    if (satelliteGrid) {
      for (let i = 0; i < 64; i++) {
        const dot = document.createElement("div");
        dot.className = "satellite-dot";
        dot.style.animationDelay = `${i * 0.1}s`;
        satelliteGrid.appendChild(dot);
      }
    }
  }, []);
  const navigate = useNavigate();

  const handleNavigation = () => {
    const token = localStorage.getItem("authToken");
    navigate(token ? "/buy" : "/login");
  };    
const array1 =  Array(5);
console.log("array1", array1);
for (let i = 0; i <= array1.length; i++) {
  console.log("hello");
}
  return (
    <>
      {/* Navigation */}
      <nav>
        <div className="nav-container">
          <h1 className="logo">Raivens Technologies</h1>
          <div className="nav-buttons">
            <a href="/login" className="button button-primary">Login</a>
            <a href="/login" className="button button-primary">Register</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="satellite-grid"></div>
        <div className="hero-container">
          <div className="hero-content">
            <div className="satellite-status">
              <i data-lucide="satellite" className="animate-pulse"></i>
              <span>Connected to Satellite Network</span>
            </div>
            <h2 className="hero-title">Bank-Grade GPS Tracking Device</h2>
            <p className="hero-description">
              Secure and precise location tracking for banking agents. Monitor all your transactions
              with satellite-powered accuracy.
            </p>
            <ul className="feature-list">
              <li className="feature-item">
                <i data-lucide="check-circle-2" className="text-green-400"></i>
                <span>Real-time location tracking</span>
              </li>
              <li className="feature-item">
                <i data-lucide="check-circle-2" className="text-green-400"></i>
                <span>Secure transaction monitoring</span>
              </li>
              <li className="feature-item">
                <i data-lucide="check-circle-2" className="text-green-400"></i>
                <span>Easy to use interface</span>
              </li>
            </ul>
            {/* <a href="/auth?tab=register" className="button button-primary"> */}
            <button onClick={handleNavigation} className="button button-primary">
              <i data-lucide="shopping-cart"></i>
              Buy Your Device Now
            </button>

            {/* </a> */}
          </div>
          <div className="device-container">
            <div className="connection-status">
              <span className="status-dot"></span>
              Connected
            </div>
            <img src={deviceImage} alt="Raviens GPS Device" className="device-image" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="features-container">
          <div className="features-header">
            <h2 className="section-title">Perfect for Banking Agents</h2>
            <p className="section-description">
              Simple, secure, and reliable GPS tracking for all your banking operations
            </p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <i data-lucide="satellite" className="feature-icon"></i>
              <h3>Satellite Connection</h3>
              <p>Always connected to satellites for precise location tracking</p>
            </div>
            <div className="feature-card">
              <i data-lucide="building-2" className="feature-icon"></i>
              <h3>Bank Integration</h3>
              <p>Seamlessly integrated with your bank's security system</p>
            </div>
            <div className="feature-card">
              <i data-lucide="banknote" className="feature-icon"></i>
              <h3>Transaction Safety</h3>
              <p>Keep track of all banking transactions with location stamps</p>
            </div>
            <div className="feature-card">
              <i data-lucide="timer" className="feature-icon"></i>
              <h3>Real-time Updates</h3>
              <p>Instant location updates for every banking operation</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="cta-container">
          <div className="satellite-icon">
            <i data-lucide="satellite" className="animate-pulse"></i>
          </div>
          <h2>Ready to Secure Your Banking Operations?</h2>
          <p className="mb-4">Join thousands of banking agents using our GPS tracking devices</p>
          <div className="button-container">

            <button onClick={handleNavigation} className="button button-primary d-inline-block me-3">
              <i data-lucide="shopping-cart"></i>
              Order Your Device Now
            </button>

            <a href="/auth" className="button button-outline d-inline-block">
              Learn More
            </a>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  );
};

export default LandingPage;
